import React from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';
import { ImageUrl } from 'src/constants/imagesConst';
import { useTranslation } from 'react-i18next';

const LoadingScreen = () => {
  const { t } = useTranslation();

  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      height="100vh"
      sx={{
        backgroundColor: '#ffffff',
        color: '#333',
        fontFamily: 'Arial, sans-serif',
        textAlign: 'center'
      }}
    >
      {/* Slika na sredini */}
      <img
        src="/kengur2/assets/kengur.png"
        alt="Loading"
        style={{
          width: '150px',
          height: 'auto',
          marginBottom: '20px'
        }}
      />

      {/* Animacija */}
      <CircularProgress
        size={60}
        thickness={4.5}
        sx={{
          color: '#2596be',
          marginBottom: '20px'
        }}
      />

      {/* Tekst */}
      <Typography
        variant="h4"
        component="div"
        sx={{
          fontWeight: 'bold',
          marginBottom: '10px'
        }}
      >
        {t('loading.title')}
      </Typography>

      <Typography variant="body1">{t('loading.description')}</Typography>
    </Box>
  );
};

export default LoadingScreen;
